import React from 'react';
import CourseCard from '../courseCard';
import ObjectiveCard from '../objectiveCard';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Copy } from 'e4shared';
import posthog from 'posthog-js';

export const ToDo = ({ history, text, objectives }) => {
    const { exploreAsideOpen } = useSelector(state => state.ui);

    if (objectives?.length === 0) {
        return (
            <div className="no-results-bold label label-success flex flex-center">
                <i className="fa fa-circle-check mr10" />
                <div className="flex-grow">
                    <Copy value={text.noResults.toDo} />
                </div>
            </div>
        );
    }

    return (
        <div>
            {objectives
                .filter(x => x.type === 'lms')
                .map(o => (
                    <CourseCard key={`course-${o.id}`} text={text} course={o} />
                ))}
            {objectives
                .filter(x => x.type === 'task')
                .sort((a, b) => (a.date1 > b.date1 ? 1 : -1))
                .map(o => (
                    <ObjectiveCard
                        key={`objective-${o.id}`}
                        text={text}
                        objective={o}
                        profileId={exploreAsideOpen.profileId}
                    />
                ))}
            {objectives?.length > 0 && (
                <div className="pull-right">
                    <button
                        data-testid="button-view-all"
                        className="btn btn-primary"
                        onClick={() => {
                            history.push(`/objectives/${exploreAsideOpen.profileId}`);
                            posthog.capture('explore menu - clicked view all objectives');
                        }}
                    >
                        {text.buttons.viewAllObjectives}
                    </button>
                </div>
            )}
        </div>
    );
};

export default withRouter(ToDo);
